import { render, staticRenderFns } from "./quality-score-modal.vue?vue&type=template&id=764bb1a3&scoped=true"
import script from "./quality-score-modal.vue?vue&type=script&lang=js"
export * from "./quality-score-modal.vue?vue&type=script&lang=js"
import style0 from "./quality-score-modal.vue?vue&type=style&index=0&id=764bb1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764bb1a3",
  null
  
)

export default component.exports